module.exports = __webpack_public_path__ + "static/img/gouliStudy.2d94e36.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/bottomNav/gouliStudy.png
// module id = xhhB
// module chunks = 1